import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Custom
import { FlagImg } from 'components/img/AssetImg';
import localeManager from 'intl/LocalesManager';
// Models
import mProduct from 'models/product';

const product = __PRODUCT__; // eslint-disable-line no-undef
const productAvailableLocales = localeManager.getAvailableLocales().filter(({ locale }) => mProduct.getAuthorizedLocales(product).includes(locale));

const LanguageSelector = ({
  value, required, errorText, onChange,
}) => (
  <Select
    label={<LocalizedMessage id="field.language" />}
    value={value}
    items={
      _map(productAvailableLocales, ({ locale, countryCode, desc }) => (
        {
          key: locale,
          value: locale,
          label: desc,
          icon: <FlagImg width={25} countryCode={countryCode} />,
        }
      ))
    }
    required={required}
    errorText={errorText}
    onChange={onChange}
  />
);

LanguageSelector.propTypes = {
  value: PropTypes.string,
  required: PropTypes.bool,
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onChange: PropTypes.func.isRequired,
};

LanguageSelector.defaultProps = {
  value: null,
  required: false,
  errorText: null,
};

module.exports = LanguageSelector;



// WEBPACK FOOTER //
// ./components/inputFields/LanguageSelector.js